import { Toggle } from "../../pages/GeneratePresentation";

  
  
  export const ProjectTogglesRow = ({projectType}) => {
    return (
          <div className="opacity-70 pt-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-6 flex-wrap">
              <h1 className="text-sm font-bold">Agents</h1>
              <Toggle
                label="Generic"
                checked={projectType === "generic"}
                onChange={() => { }}
              />
              <Toggle
                label="Marketing Insights"
                checked={projectType === "marketing"}
                onChange={() => { }}
              />
              <Toggle
                label="Analytics Financial"
                checked={projectType === "finance"}
                onChange={() => { }}
              />
            </div>
        
          </div>
    );
  }